import { DirectionalHint } from "@fluentui/react";

export const TooltipHostCalloutProps = { gapSpace: 0, beakWidth: 12, directionalHint: DirectionalHint.topCenter };
export const topCalloutProps = { gapSpace: 0, beakWidth: 12, directionalHint: DirectionalHint.topLeftEdge };
